import { color as foundationColor } from "../foundation";

const { primary, secondary, error, warning, info, success, neutral } = foundationColor;

export const color = {
  bg: {
    primary: neutral.white,     // overall app background for the body element
    surface: neutral.white,     // surfaces of components like cards, modals, dropdowns, etc.
    navMain: secondary[600],    // main navigation background
    navSub: neutral[50],        // sub navigation background
    disabled: neutral[300],     // disabled backgrounds for form fields, etc.
    success: success[100],      // success state backgrounds for form fields, alerts, etc.
    error: error[100],          // error state backgrounds for form fields, alerts, etc.
    warning: warning[100],      // warning state backgrounds for form fields, alerts, etc.
    info: info[100],            // info state backgrounds for form fields, alerts, etc.
    container: {
      active: info[50],         // active state background for container components like cards, list items, etc.
      muted: neutral[50],       // disabled and nested state background for container components like cards, list items, etc.
    },
  },

  text: {
    heading: neutral[900],    // primary text color for headings and high emphasis text
    body: neutral[700],       // primary text color for body copy and medium emphasis text - set using palette.text.primary in theme.js
    muted: neutral[600],      // secondary text color for subdued text, use for field labels and form descriptors - set using palette.text.secondary in theme.js
    disabled: neutral[500],   // disabled text color for field values or inactive items and labels - set using palette.text.disabled in theme.js
    link: primary[600],       // default link color for text links
    linkHover: primary[500],  // hover state for text links
    linkActive: primary[700], // active state for text links
    success: success[900],    // success state text color for form fields, alerts, etc.
    error: error[700],        // error state text color for form fields, alerts, etc.
    warning: warning[700],    // warning state text color for form fields, alerts, etc.
    info: info[800],          // info state text color for form fields, alerts, etc.
    navLight: neutral[800],   // text color for nav items on light backgrounds
    active: primary[700],     // color for text in active state containers with blue background
  },

  icons: {
    primary: primary[600],
    secondary: secondary[600],
    tertiary: neutral[600],
    success: success[600],    // success state icon color for form fields, alerts, etc.
    error: error[600],        // error state icon color for form fields, alerts, etc.
    warning: warning[600],    // warning state icon color for form fields, alerts, etc.
    info: info[600],          // info state icon color for form fields, alerts, etc.
    heading: neutral[900],    // icon color for icons in panel headers.
  },

  border: {
    default: {
    light: neutral[300],      // default border color for cards, panels, etc.  
    medium: neutral[400],
    dark: neutral[500],
    },
    active: {
      light: info[400],
      medium: info[500],      // default border for active containers
      dark: info[700],        // hover state border for active containers
    }
  }
}

export default color;